document.addEventListener("DOMContentLoaded", function () {

  function setupSeriesInputs() {
    const seriesInputs = document.querySelectorAll('quantity-input');

    seriesInputs.forEach(qtyWrapper => {
      const input = qtyWrapper.querySelector('input.quantity__input');
      if (!input) return;

      const SERIES_SIZE = parseInt(qtyWrapper.dataset.series) || 4;

      // Başlangıç değeri
      if (!input.value || parseInt(input.value) < SERIES_SIZE) {
        input.value = SERIES_SIZE;
      }

      // Artırma / Azaltma işlemleri
      qtyWrapper.querySelectorAll('button').forEach(btn => {
        btn.removeEventListener('click', btn._seriesClick); // önce varsa temizle
        const handler = () => {
          let val = parseInt(input.value) || SERIES_SIZE;

          if (btn.name === "increment") {
            val += SERIES_SIZE;
          } else if (btn.name === "minus" || btn.name === "decrement") {
            val -= SERIES_SIZE;
            if (val < SERIES_SIZE) val = SERIES_SIZE;
          }

          input.value = val;
        };
        btn.addEventListener('click', handler);
        btn._seriesClick = handler; // tekrar eklenmemesi için
      });

      // Manuel giriş değişirse 4'ün katına yuvarla
      input.removeEventListener('change', input._seriesChange);
      const changeHandler = () => {
        let val = parseInt(input.value) || SERIES_SIZE;
        if (val < SERIES_SIZE) val = SERIES_SIZE;
        if (val % SERIES_SIZE !== 0) {
          val = Math.ceil(val / SERIES_SIZE) * SERIES_SIZE;
        }
        input.value = val;
      };
      input.addEventListener('change', changeHandler);
      input._seriesChange = changeHandler;
    });
  }

  // İlk yükleme
  setupSeriesInputs();

  // Variant değişirse resetle
  document.addEventListener("variant:changed", setupSeriesInputs);

  // Dinamik sayfa güncellemeleri için (View Cart gibi)
  const observer = new MutationObserver(setupSeriesInputs);
  observer.observe(document.body, { childList: true, subtree: true });

});
